let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Wx3P")).then(() => parcelRequire('fhfEu'));